<template>
    <div style="display:  inline-block;">
      <div @click="open()" style="display:  inline-block;">
        <slot></slot>
      </div>
      <el-dialog width="70%" title="自定义显示字段" :visible="dialogVisible" @close="dialogVisible=false">
            <el-row>
                <el-col :span="24">
                    <el-card>
                        <div slot="header" class="card-header">
                            <span>全部字段</span>
                        </div>
                        <el-checkbox-group v-model="selectCol" @change="handleChangeSelectColumn">
                            <vuedraggable animation="180" @end="onEnd">
                                <el-checkbox v-for="item in columnAll" :key="item.label" :label="item.label" :disabled="item.disabled" class="col-list">
                                    {{ item.label }}
                                </el-checkbox >
                            </vuedraggable>
                        </el-checkbox-group>
                    </el-card>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible=false">取 消</el-button>
                <el-button type="primary" @click="updateColumn">确 定</el-button>
            </div>
        </el-dialog>
    </div>
   
</template>

<script>
import vuedraggable from 'vuedraggable'
export default {
  components: { vuedraggable },
  props:{
    tableRef:{
      type:Object
    }
  },
  mounted() {
  },

  data() {
    return {
      table:null,
      dialogVisible: false,
      columnAll:[],
      selectCol:[]
    };
  },

  methods: {
    onEnd(event){
            const [oldIndex,newIndex] = [event.oldIndex, event.newIndex];
            let direction,min,max;
            if( oldIndex < newIndex){
                direction = "back";
                min = oldIndex;
                max = newIndex;
            }else{
                direction = "forward";
                min = newIndex;
                max = oldIndex;
            }
            if( direction === "forward"){
                this.$set(this.columnAll[max],"index", min);
                for(let i = min;  i < max ; i++ ){
                    const index = this.columnAll[i].index + 1;
                    this.$set(this.columnAll[i],"index",index)
                }
            }else{
                this.$set(this.columnAll[min],"index", max);
                for(let i = max;  i > min ; i-- ){
                    const index = this.columnAll[i].index - 1;
                    this.$set(this.columnAll[i],"index",index)
                }
            }

            this.columnAll.sort((a, b) => {
                return a.index - b.index;
            });
            // this.handleColChange();

        },
    handleChangeSelectColumn(){
        this.columnAll.forEach((item) => {
            if (this.selectCol.includes(item.label)) {
                this.$set(item, "checked", true);
            } else {
                this.$set(item, "checked",false);
            }
        });
        // this.handleColChange();
    },
    open(){
      debugger
      var that = this;
      if(this.tableRef){
        this.table = this.tableRef;
      }else{
        var refs = this.$parent.$parent.$refs
        for(var name in refs){
          if(refs[name].tableId && refs[name].store){
            this.table = refs[name]
            break;
          }
        }
      }
      var states = this.table.store.states;
      if(that.columnAll.length == 0){
        states.columns.forEach((item,index) =>{
          item.checked = true;
          item.index = index
          that.columnAll.push(item)
          that.selectCol.push(item.label)
        })
      }
      this.dialogVisible = true;
    },
    updateColumn() {
      var that = this;
      var table = this.table;
      var store = table.store;
      var states = store.states;
      states._columns = []
      states.columns = []
      that.columnAll.forEach(item=>{
        if(item.checked){
          states._columns.push(item)
          states.columns.push(item)
        }
      })

      if (table.$ready) {
        store.updateColumns()
        store.scheduleLayout();
        table.doLayout();
        table.resizeState = {
          width: table.$el.offsetWidth,
          height: table.$el.offsetHeight
        };

        // init filters
        store.states.columns.forEach(column => {
          if (column.filteredValue && column.filteredValue.length) {
            store.commit('filterChange', {
              column,
              values: column.filteredValue,
              silent: true
            });
          }
        });

        table.$ready = true;
      }
      this.dialogVisible = false;
    },
  }
}
</script>

<style>
</style>